import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import Mousetrap from 'mousetrap';
import 'mousetrap/plugins/global-bind/mousetrap-global-bind';
import { forEach } from 'lodash';
/**
 * WordPress dependencies
 */

import { Component, Children } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { isAppleOS } from './platform';

var KeyboardShortcuts =
/*#__PURE__*/
function (_Component) {
  _inherits(KeyboardShortcuts, _Component);

  function KeyboardShortcuts() {
    var _this;

    _classCallCheck(this, KeyboardShortcuts);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KeyboardShortcuts).apply(this, arguments));
    _this.bindKeyTarget = _this.bindKeyTarget.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(KeyboardShortcuts, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$keyTarget = this.keyTarget,
          keyTarget = _this$keyTarget === void 0 ? document : _this$keyTarget;
      this.mousetrap = new Mousetrap(keyTarget);
      forEach(this.props.shortcuts, function (callback, key) {
        if (process.env.NODE_ENV === 'development') {
          var keys = key.split('+');
          var modifiers = new Set(keys.filter(function (value) {
            return value.length > 1;
          }));
          var hasAlt = modifiers.has('alt');
          var hasShift = modifiers.has('shift');

          if (isAppleOS() && (modifiers.size === 1 && hasAlt || modifiers.size === 2 && hasAlt && hasShift)) {
            throw new Error("Cannot bind ".concat(key, ". Alt and Shift+Alt modifiers are reserved for character input."));
          }
        }

        var _this2$props = _this2.props,
            bindGlobal = _this2$props.bindGlobal,
            eventName = _this2$props.eventName;
        var bindFn = bindGlobal ? 'bindGlobal' : 'bind';

        _this2.mousetrap[bindFn](key, callback, eventName);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mousetrap.reset();
    }
    /**
     * When rendering with children, binds the wrapper node on which events
     * will be bound.
     *
     * @param {Element} node Key event target.
     */

  }, {
    key: "bindKeyTarget",
    value: function bindKeyTarget(node) {
      this.keyTarget = node;
    }
  }, {
    key: "render",
    value: function render() {
      // Render as non-visual if there are no children pressed. Keyboard
      // events will be bound to the document instead.
      var children = this.props.children;

      if (!Children.count(children)) {
        return null;
      }

      return createElement("div", {
        ref: this.bindKeyTarget
      }, children);
    }
  }]);

  return KeyboardShortcuts;
}(Component);

export default KeyboardShortcuts;
//# sourceMappingURL=index.js.map